import React, { useEffect, useState } from "react";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { Link } from "react-router-dom";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import { getBatchList } from "../../../api/BatchService";
import {
  followlist,
  followresponse,
  studentlist,
} from "../../../api/EnquiryService";
import DownloadExcel from "../../master/DownloadExcel";

const AlocateData = () => {
  const [data, setdata] = useState([]);
  const [course, setcourse] = useState([]);
  const [status, setStatus] = useState("");
  const [enquiry, setEnquiry] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState("");
  const [modalData, setModalData] = useState(null);

  const [showBatch, setShowBatch] = useState(false);
  const [batches, setBatches] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedSource, setSelectedSource] = useState("");
  const [selectedCounselor, setSelectedCounselor] = useState("");
  const openModal = (id) => () => {
    const modal = new window.bootstrap.Modal(document.getElementById(id));
    modal.show();
  };

  const getEnquiries = async () => {
    setLoading(true);
    let addUrl = `&status=${status}&page=${page}`;
    if (search) addUrl += `&search=${search}`;

    try {
      let response;

      if (status === "1") {
        // Fees Deposit API
        response = await studentlist(addUrl); // Replace with your actual API
      } else {
        // Enquiry API
        response = await followlist(addUrl);
      }

      if (response.data.status) {
        setEnquiry(response?.data?.data);
      } else {
        // ToastMain.fire({
        //     icon: "info",
        //     title: response?.data?.message || "Something Went Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: "error",
      //     title:
      //         error?.response?.data?.message ||
      //         error?.response?.message ||
      //         "Something Went Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEnquiries();
  }, [status, page, search]);
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl, {
        delay: { show: 0, hide: 0 }, // ✅ No delay
      });
    });
  }, []);
  useEffect(() => {
    getEnquiries();
  }, [status, page, search]);

  const enquiryFollowUp = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    // formData.append("Type", modalData.type);

    try {
      const response = await followresponse(formData);
      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Response Add Successfully!",
        }).then(() => {
          window.location.reload();
        });
      } else {
        // ToastMain.fire({
        //     icon: "info",
        //     title: response?.data?.message || "Something Went Wrong!",
        // }).then(() => {
        //     setLoading(false);
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: "error",
      //     title: error?.response?.data?.message || error?.response?.message || "Something Went Wrong!",
      // }).then(() => {
      //     setLoading(false);
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();

    let searchInput = e.target.search.value;
    if (searchInput) setSearch(searchInput);
  };

  useEffect(() => {
    if (showBatch && modalData?.course_id) {
      getBatches(modalData?.course_id);
    }
  }, [showBatch, modalData]);

  const getBatches = async (id) => {
    setLoading(true);
    let addUrl = `&course_id=${id}`;
    try {
      const response = await getBatchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.batches);
      } else {
        // ToastMain.fire({
        //     icon: "info",
        //     title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: "error",
      //     title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    const exportData = enquiry?.data || []; // ✅ Correct path
    if (exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    DownloadExcel(
      exportData,
      ["SN", "Student Name", "response", "followup_date"],
      "Enquiry List",
      [
        { type: "rename", oldKey: "student_name", newKey: "Student Name" },
        { type: "rename", oldKey: "father_name", newKey: "Father Name" },
        { type: "add", newKey: "Time", value: "00:00:00" },
      ]
    );
  };
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card shadow-sm p-4">
                      <h4 className="text-primary fw-bold mb-5">
                        All Allocate Data
                      </h4>

                      <div className="col-md-12 row g-3 mb-4">
                        {/* Counselor Dropdown */}
                        <div className="col-md-3 form-floating form-floating-outline">
                          <select
                            className="form-control"
                            value={selectedCounselor}
                            onChange={(e) =>
                              setSelectedCounselor(e.target.value)
                            }
                          >
                            <option value="">Select Counselor</option>{" "}
                            {/* default empty */}
                            <option>MANOJ</option>
                            <option>RAVI</option>
                            <option>AMAN</option>
                            <option>VIVEK</option>
                            <option>PREETI</option>
                          </select>
                          <label>Select Counselor</label>
                        </div>

                        {/* Show only if counselor selected */}
                        {selectedCounselor && (
                          <>
                            {/* Source Dropdown */}
                            <div className="col-md-3 form-floating form-floating-outline">
                              <select
                                className="form-control"
                                value={selectedSource}
                                onChange={(e) =>
                                  setSelectedSource(e.target.value)
                                }
                              >
                                <option value="">Select Source</option>
                                <option value="Marketing">Marketing</option>
                                <option value="Enquiry">Enquiry</option>
                                <option value="fee Deposite">
                                  fee Deposite
                                </option>
                              </select>
                              <label>Select Type</label>
                            </div>

                            {/* Conditionally Rendered Input - Marketing */}
                            {selectedSource === "Marketing" && (
                              <div className="col-md-3 form-floating form-floating-outline mt-2">
                                <select className="form-control">
                                  <option>Bala ji</option>
                                  <option>Whatsapp</option>
                                  <option>Instagram</option>
                                </select>
                                <label>Select Source </label>
                              </div>
                            )}

                            {/* Conditionally Rendered Input - Fee Deposite */}
                            {selectedSource === "fee Deposite" && (
                              <div className="col-md-3 form-floating form-floating-outline mt-2">
                                <select className="form-control">
                                  <option>Apna load</option>
                                  <option>10th</option>
                                  <option>11th</option>
                                </select>
                                <label>Select Batch</label>
                              </div>
                            )}
                          </>
                        )}

                        {/* Search & Submit Form */}
                        <div className="col-md-6">
                          <form className="row" onSubmit={handleFilter}>
                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Name, Mobile"
                                name="search"
                                onChange={(e) => {
                                  e.target.value = e.target.value.toUpperCase();
                                }}
                              />
                              <label>Search by Name, Mobile</label>
                            </div>
                            <div className="col-md-4 col-sm-5 mt-1">
                              <button
                                type="submit"
                                className="btn btn-label-primary me-1"
                              >
                                <i className="ri-arrow-right-line ri-20px" />
                              </button>
                              <a href="?" className="btn btn-label-danger me-1">
                                <i className="ri-restart-line ri-20px" />
                              </a>
                            </div>
                          </form>
                        </div>
                      </div>

                      {/* Table */}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="card mt-5 p-3 py-4">
                      <div className="table-responsive">
                        <table className="table  table-sm table-hover">
                          <thead className="table-primary">
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              {/* <th>Response</th> */}
                              <th>date</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {enquiry?.data?.length === 0 ? (
                              <tr>
                                <td colSpan="10">No enquiries found</td>
                              </tr>
                            ) : (
                              enquiry?.data?.map((item, i) => (
                                <tr key={item.id}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {item.status === "1"
                                      ? item?.student_info.name
                                      : item.student_name}
                                  </td>

                                  {/* <td>{item?.enquiry_response?.response}</td> */}
                                  <td>{item?.followup_date}</td>
                                  <td>
                                    <div className="demo-inline-spacing py-0 my-0">
                                      <div
                                        className="btn-group py-0 my-0"
                                        id="hover-dropdown-demo"
                                      >
                                        <button
                                          type="button"
                                          className="btn dropdown-toggle py-0 my-0"
                                          data-bs-toggle="dropdown"
                                          data-trigger="hover"
                                          aria-expanded="false"
                                        >
                                          <i className="bi bi-three-dots-vertical" />
                                        </button>
                                        <ul className="dropdown-menu py-0">
                                          <li>
                                            <Link
                                              to={
                                                item.status === "1"
                                                  ? `/student/details?id=${item.id}`
                                                  : `/enquiry/detail?id=${item.id}`
                                              }
                                              className="dropdown-item"
                                            >
                                              <i className="bi bi-eye text-success mx-1"></i>
                                              View
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlocateData;
